var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "initial_page"
  }, [_c('div', {
    staticClass: "main_page"
  }, [_vm._m(0), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "reset_form"
  }, [_c('h3', [_vm._v("Verify OTP")]), _c('b-form-group', {
    attrs: {
      "label": "Enter OTP",
      "label-for": "input-2"
    }
  }, [_c('b-input-group', {
    attrs: {
      "id": "input-2"
    }
  }, [_c('div', {
    attrs: {
      "id": "otp"
    }
  }, [_c('b-form-input', {
    class: _vm.errorClass,
    attrs: {
      "type": "text",
      "maxlength": "1",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.otp.one,
      callback: function ($$v) {
        _vm.$set(_vm.otp, "one", $$v);
      },
      expression: "otp.one"
    }
  }), _c('b-form-input', {
    class: _vm.errorClass,
    attrs: {
      "type": "text",
      "maxlength": "1",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.otp.two,
      callback: function ($$v) {
        _vm.$set(_vm.otp, "two", $$v);
      },
      expression: "otp.two"
    }
  }), _c('b-form-input', {
    class: _vm.errorClass,
    attrs: {
      "type": "text",
      "maxlength": "1",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.otp.three,
      callback: function ($$v) {
        _vm.$set(_vm.otp, "three", $$v);
      },
      expression: "otp.three"
    }
  }), _c('b-form-input', {
    class: _vm.errorClass,
    attrs: {
      "type": "text",
      "maxlength": "1",
      "required": "",
      "placeholder": "0"
    },
    model: {
      value: _vm.otp.four,
      callback: function ($$v) {
        _vm.$set(_vm.otp, "four", $$v);
      },
      expression: "otp.four"
    }
  })], 1)])], 1), _vm.formErrorFlag == true ? _c('div', {
    staticClass: "error_message"
  }, [_vm._v(" " + _vm._s(_vm.formErrors["error"]) + " ")]) : _vm._e(), _c('OTPTimer', {
    attrs: {
      "title": "Not received? Click to resend",
      "expirySecond": 60
    },
    on: {
      "sendOTP": _vm.sendOtpCode
    }
  }), _c('button', {
    attrs: {
      "disabled": _vm.verifyLoader
    },
    on: {
      "click": _vm.verifyToken
    }
  }, [_vm.verifyLoader == true ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Verify OTP ")], 1)], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "forgot_welcome"
  }, [_c('h1', [_vm._v("Forgot your Password?")]), _c('p', [_vm._v(" Enter the OTP code you received in your email or phone. ")])]);

}]

export { render, staticRenderFns }